import { ButtonV2, Flex, styled, TextV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { BANK_PARTNER_PROMO_FONT_FAMILY } from './constants';

export const transferDialogOverrides = {
  Content: {
    props: {
      width: pxToRem(480),
      maxWidth: '100%',
    },
  },
};

export const TransferDialogBody = styled(Flex)`
  flex-direction: column;
  background: white;
  min-height: 100%;
`;

export const AllyPromoHeadline = styled(TextV2)`
  font-size: ${pxToRem(26)};
  font-weight: 700;
  font-family: ${BANK_PARTNER_PROMO_FONT_FAMILY};
  color: #1a1a1a;
  line-height: 1.25;
  letter-spacing: -0.5px;
`;

export const AllyPromoSubtext = styled(TextV2)`
  font-size: ${pxToRem(16)};
  font-family: ${BANK_PARTNER_PROMO_FONT_FAMILY};
  color: #777;
  line-height: 1.7;
  font-weight: 400;
`;

export const AllyAmountDisplay = styled(TextV2)`
  font-size: ${pxToRem(70)};
  font-weight: 800;
  font-family: ${BANK_PARTNER_PROMO_FONT_FAMILY};
  letter-spacing: -3px;
  line-height: 1;
  margin-bottom: ${pxToRem(8)};
  transition: color 0.4s ease;
`;

export const AllyAmountSubtext = styled(TextV2)`
  font-size: ${pxToRem(13)};
  font-family: ${BANK_PARTNER_PROMO_FONT_FAMILY};
  color: #888;
  margin-bottom: ${pxToRem(32)};
  letter-spacing: 0.2px;
`;

export const AllyNudgeBar = styled(Flex)`
  background: #f2ede8;
  border-radius: ${pxToRem(12)};
  padding: ${pxToRem(14)} ${pxToRem(16)};
  margin-bottom: ${pxToRem(12)};
  text-align: left;
  flex-direction: column;
  gap: ${pxToRem(12)};
`;

export const AllyNudgeText = styled(TextV2)`
  font-size: ${pxToRem(13)};
  font-family: ${BANK_PARTNER_PROMO_FONT_FAMILY};
  color: #666;
  line-height: 1.6;
`;

export const AllyPrimaryButton = styled(ButtonV2)`
  width: 100%;
  margin-bottom: ${pxToRem(10)};
`;

export const AllySecondaryButton = styled(ButtonV2)`
  width: 100%;
  margin-bottom: ${pxToRem(24)};
  && {
    color: #aaa;
    border-color: #e8e8e8;
  }
  &&:hover {
    color: #777;
    border-color: #d0d0d0;
  }
`;

export const AllyFinePrint = styled(TextV2)`
  font-size: ${pxToRem(11)};
  font-family: ${BANK_PARTNER_PROMO_FONT_FAMILY};
  color: #aaa;
  line-height: 1.7;
`;

export const RevolutAmountPrefix = styled(TextV2)`
  font-size: ${pxToRem(48)};
  font-weight: 800;
  font-family: ${BANK_PARTNER_PROMO_FONT_FAMILY};
  color: #111111;
  line-height: 1;
  white-space: nowrap;
`;

export const RevolutAmountDisplay = styled(TextV2)`
  font-size: ${pxToRem(52)};
  font-weight: 800;
  font-family: ${BANK_PARTNER_PROMO_FONT_FAMILY};
  letter-spacing: -3px;
  line-height: 1;
  margin-bottom: ${pxToRem(8)};
  transition: color 0.4s ease;
`;

export const RevolutApyDisplay = styled(TextV2)`
  font-size: ${pxToRem(48)};
  font-weight: 800;
  font-family: ${BANK_PARTNER_PROMO_FONT_FAMILY};
  letter-spacing: -2px;
  line-height: 1;
`;

export const RevolutAmountSubtext = styled(TextV2)`
  font-size: ${pxToRem(13)};
  font-family: ${BANK_PARTNER_PROMO_FONT_FAMILY};
  color: #555;
  letter-spacing: 0.2px;
`;

export const RevolutPromoHeadline = styled(TextV2)`
  font-size: ${pxToRem(22)};
  font-weight: 700;
  font-family: ${BANK_PARTNER_PROMO_FONT_FAMILY};
  color: #1a1a1a;
  line-height: 1.3;
`;

export const RevolutPromoSubtext = styled(TextV2)`
  font-size: ${pxToRem(18)};
  font-family: ${BANK_PARTNER_PROMO_FONT_FAMILY};
  color: #555;
  line-height: 1.4;
  font-weight: 400;
`;

export const RevolutPrimaryButton = styled(ButtonV2)`
  width: 100%;
  margin-bottom: ${pxToRem(10)};
`;

export const RevolutSecondaryButton = styled(ButtonV2)`
  width: 100%;
  margin-bottom: ${pxToRem(16)};
  && {
    color: #666;
    border-width: 2px;
    border-color: #c0c0c0;
  }
  &&:hover {
    color: #444;
    border-color: #a0a0a0;
  }
`;

export const RevolutFinePrint = styled(TextV2)`
  font-size: ${pxToRem(11)};
  font-family: ${BANK_PARTNER_PROMO_FONT_FAMILY};
  color: #555;
  line-height: 1.7;
`;

export const RevolutDisclaimerToggle = styled(TextV2)`
  font-size: ${pxToRem(11)};
  font-family: ${BANK_PARTNER_PROMO_FONT_FAMILY};
  color: #555;
  text-decoration: underline;
  cursor: pointer;
  margin-top: ${pxToRem(8)};
  background: none;
  border: none;
  padding: 0;
`;
